<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from "axios";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";


import {
  required,
  //email,
  //minLength,
  //sameAs,
  //maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
  //requiredIf
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Model",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Multiselect, DatePicker/*Basic*/ },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      info: null,
      title: "Document building",
      componentKey: 0,
      standardCount: 0,
      maxEquipment: false,
      items: [
        {
          text: "Document",
          href: "/"
        },
        {
          text: "Documents",
          href: "/documents/third pary"
        },
        {
          text: "Third Party",
          active: true
        }
      ],
      customers:              [],
      categories:             [],
      customerContacts:       [],
      customerLocations:      [],
      document:               {},
      form: {
        id_type:              "",
        id_customer:          "",
        id_customerContact:   "",
        id_customerLocation:  "",
        id_categories:        [],

        de_safetyFoodCode:    "",

        id_preparedBy:        "",
        id_approvedBy:        "",
        dt_revisionDate:      "",
        dt_approvalDate:      "",
      },
      
      submitted: false,
    };
  },
  validations: {
    form: {
      id_type:                { required },
      id_customer:            { required },
      id_customerLocation:    { required },
      id_customerContact:     { required },
      id_categories:          { required },

      de_safetyFoodCode:      { required },

      id_preparedBy:          { required },
      id_approvedBy:          { required },
      dt_revisionDate:        { required },
      dt_approvalDate:        { required },
    }
  },
  watch:{
    form:{
      handler: function(newValue, oldValue){
        newValue;
        oldValue;
        //console.log(newValue.id_industry, oldValue.id_industry);
      },
      deep: true,
    },
  },
  created(){
    this.getCategories();
    this.getThirdPartyCustomers();

    if( this.$route.params.id ){
      console.log('algo');
    }
  },
  mounted() {

  },
  methods: {

    getCategories(){
      let app = this;

      if(this.customers.length == 0){
        Swal.fire({
          title: 'Getting categories.',
          showConfirmButton:false,
        });

        axios
        .get(
          window.serverPath+'dist/mvw/controllers/categories.php',
          {
            params: {
              request: 'getCategoriesForMultipleSelect',
            }
          }
        )
        .then(response => {
          Swal.close();
          if( response.statusText == "OK" ){
            if(response.data){
              app.categories  = response.data
            }else{
              Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
            }
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          console.log(error);
          app.isLoading = false;
          if(
            error.code == "ERR_BAD_RESPONSE"    ||
            error.code == "ERR_NETWORK"
          ){
            Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
          }
        });
      }
    },

    getThirdPartyCustomers(){
      let app = this;

      if(this.customers.length == 0){
        Swal.fire({
          title: 'Getting customers.',
          showConfirmButton:false,
        });

        axios
        .get(
          window.serverPath+'dist/mvw/controllers/customers.php',
          {
            params: {
              request: 'getThirdPartyCustomersForMultiselect',
            }
          }
        )
        .then(response => {
          Swal.close();
          if( response.statusText == "OK" ){
            if(response.data){
              app.customers  = response.data
            }else{
              Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
            }
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          console.log(error);
          app.isLoading = false;
          if(
            error.code == "ERR_BAD_RESPONSE"    ||
            error.code == "ERR_NETWORK"
          ){
            Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
          }
        });
      }
    },

    getCustomerContacts(){
      let app         = this;
      let idCustomer;

      this.customerContacts         = [];
      this.form.id_customerContact  = [];

      idCustomer = this.form.id_customer.value;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:      'getCustomerContactsByCustomerIDForMultipleSelect',
            idCustomer:   idCustomer
          }
        }
      )
      .then(response => {
        console.log(response);
        app.$swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.customerContacts  = response.data
          }else{
            app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          app.$swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCustomerLocations(){
      let app         = this;
      let idCustomer;

      this.customerLocations         = [];
      this.form.id_customerLocation  = [];

      idCustomer = this.form.id_customer.value;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:      'getCustomerLocationsByCustomerIDForMultipleSelect',
            idCustomer:   idCustomer
          }
        }
      )
      .then(response => {
        console.log(response);
        app.$swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.customerLocations  = response.data
          }else{
            app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          app.$swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    // eslint-disable-next-line no-unused-vars
    saveEquipment(e) {
      let app       = this;
      //let action    = "";

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          //this.form.id_equipment = this.$route.params.id;
        }

        Swal.fire({
          title: "Generating Third Party Documents. This may take a while.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        app.document.id_type                = this.form.id_type;
        app.document.id_customer            = this.form.id_customer;
        app.document.id_customerLocation    = this.form.id_customerLocation;
        app.document.id_customerContact     = this.form.id_customerContact;
        app.document.id_categories          = this.form.id_categories;

        app.document.de_safetyFoodCode      = this.form.de_safetyFoodCode;

        app.document.id_preparedBy          = this.form.id_preparedBy.nm_contact;
        app.document.id_preparedByPosition  = this.form.id_preparedBy.de_position;
        app.document.id_preparedByEmail     = this.form.id_preparedBy.de_contactEmail;
        app.document.id_preparedByPhone     = this.form.id_preparedBy.num_contactPhoneNumber;

        app.document.id_approvedBy          = this.form.id_approvedBy.nm_contact;
        app.document.id_approvedByPosition  = this.form.id_approvedBy.de_position;
        app.document.id_approvedByEmail     = this.form.id_approvedBy.de_contactEmail;
        app.document.id_approvedByPhone     = this.form.id_approvedBy.num_contactPhoneNumber;

        app.document.dt_revisionDate        = this.form.dt_revisionDate;
        app.document.dt_approvalDate        = this.form.dt_approvalDate;

        axios.post(window.serverPath+'dist/mvw/placeholders.php', {
          request: 'createThirdPartyDocuments',
          data: app.document, 
        })
        .then(response => {
            //app.$swal.close();
            if( response.statusText == "OK" ){
                //app.createDocument(app.document);
                //action = "saved";
              window.open(window.serverPath+"dist/mvw/"+response.data);
              Swal.close();
            }else{
              Swal.close();
              Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
            }
        /*
        .then(async function (response) {
          if( response.data === "OK" ){
            app.createDocument(app.document);
            
          }
        */

          //Swal.fire("Good job!", "Your equipment is correct "+action+"!", "success");
          //app.$router.push({ name: 'equipments' });
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation">
              <div class="row">
                <div class="col-lg-8">
                  <h4 class="card-title">Customer Information</h4>
                  <p class="card-title-desc">Choose the customer you'll build a GoHACCP plan.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_type">Third party document type</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_type.$error }"
                          name="id_type"
                          id="id_type"
                          v-model="form.id_type"
                        >
                          <option value="">SELECT DOCUMENT TYPE</option>
                          <option value="1">SQF</option>
                          <option value="2">NSF</option>
                        </select>
                        <div v-if="submitted && $v.form.id_type.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_type.required">Third party document type field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_states">Customer</label>
                        <multiselect
                          :class="{ 'is-invalid': submitted && $v.form.id_customer.$error }"
                          id="id_customer"
                          v-model="form.id_customer"
                          :options="customers"
                          :multiple="false"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT YOUR CUSTOMERS"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                          @select="getCustomerContacts(); getCustomerLocations()"
                        ></multiselect>
                        <div v-if="submitted && $v.form.id_customer.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_customer.required">Customer field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_states">Customer Location</label>
                        <multiselect
                          :class="{ 'is-invalid': submitted && $v.form.id_customerLocation.$error }"
                          id="id_customerLocation"
                          v-model="form.id_customerLocation"
                          :options="customerLocations"
                          :multiple="false"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT CUSTOMERS LOCATION"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                        ></multiselect>
                        <div v-if="submitted && $v.form.id_customerLocation.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_customerLocation.required">Customer location field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_customerContact">Customer Contact</label>
                        <multiselect
                          v-model="form.id_customerContact"
                          :options="customerContacts"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT CUSTOMER CONTACT"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                        >
                        </multiselect>
                        <div v-if="submitted && $v.form.id_customerContact.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_customerContact.required">Customer Contact field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_categories">Equipment Categories</label>
                        <multiselect
                          v-model="form.id_categories"
                          :options="categories"
                          :multiple="true"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT EQUIPMENT CATEGORY"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                        >
                        </multiselect>
                        <div v-if="submitted && $v.form.id_categories.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_categories.required">Equipment categories field is required. Please select at least 1 option.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_safetyFoodCode">Safety food code</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_safetyFoodCode.$error }"
                          name="de_safetyFoodCode"
                          id="de_safetyFoodCode"
                          v-model="form.de_safetyFoodCode"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_safetyFoodCode.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_safetyFoodCode.required">Safety food code is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                
                <div class="col-lg-4">
                  <h4 class="card-title">Record information</h4>
                  <p class="card-title-desc">Please fill the record information for the proper completion of the documents.</p>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="id_preparedBy">Prepared by?</label>
                        <multiselect
                          v-model="form.id_preparedBy"
                          :options="customerContacts"
                          :multiple="false"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT APPROVAL PERSON"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                        >
                        </multiselect>
                        <div v-if="submitted && $v.form.id_preparedBy.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_preparedBy.required">This field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dt_revisionDate">Revision Date</label>
                        <br />
                        <date-picker
                          v-model="form.dt_revisionDate"
                          :first-day-of-week="1"
                          lang="en"
                          :class="{ 'is-invalid': $v.form.dt_revisionDate.$error }"
                          name="dt_revisionDate"
                          id="dt_revisionDate"
                          valueType="format"
                          format="YYYY-MM-DD"
                          :value="form.dt_revisionDate"
                        >
                        </date-picker>
                        <div v-if="$v.form.dt_revisionDate.$error" class="invalid-feedback">
                          <span v-if="!$v.form.dt_revisionDate.required">Revision date is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_approvedBy">Approved by?</label>
                        <multiselect
                          v-model="form.id_approvedBy"
                          :options="customerContacts"
                          :multiple="false"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="SELECT APPROVAL PERSON"
                          label="label"
                          track-by="label"
                          :preselect-first="false"
                        >
                        </multiselect>
                        <div v-if="submitted && $v.form.id_approvedBy.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_approvedBy.required">Approval person field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dt_approvalDate">Approval Date</label>
                        <br />
                        <date-picker
                          v-model="form.dt_approvalDate"
                          :first-day-of-week="1"
                          lang="en"
                          :class="{ 'is-invalid': $v.form.dt_approvalDate.$error }"
                          name="dt_approvalDate"
                          id="dt_approvalDate"
                          valueType="format"
                          format="YYYY-MM-DD"
                          :value="form.dt_approvalDate"
                        >
                        </date-picker>
                        <div v-if="$v.form.dt_approvalDate.$error" class="invalid-feedback">
                          <span v-if="!$v.form.dt_approvalDate.required">Approval date is required.</span>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
                
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="button" @click="saveEquipment">CREATE DOCUMENTS</button>
                    <router-link to="/documents/thirdparties" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
          </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
<style type="text/css">
  .v-multiselect__menu{
    z-index: 999 !important;
  }
  .multiselect__placeholder {
    color: #000000 !important;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
}
</style>